import React from 'react';
import { Link } from 'react-router-dom';
import {
  CustomsIcon,
  FinanceIcon,
  ForwardingIcon,
  InsightsIcon,
  PricingIcon,
  SalesIcon,
  ServicesBg,
  TransportIcon,
  WarehouseIcon,
} from '../../assets';
import './Services.css';

const Services = () => {
  const content = {
    title: 'Our Unified Suite of Apps & Copilot',
    imageSrc: ServicesBg,
    backgroundColor: '#FE6533',
    titleColor: '#FFFFFF',
  };

  const services = [
    {
      name: 'Sales',
      icon: SalesIcon,
      path: '/products/sales',
    },
    {
      name: 'Pricing',
      icon: PricingIcon,
      path: '/products/sales',
    },
    {
      name: 'Forwarding',
      icon: ForwardingIcon,
      path: '/products/forwarding',
    },
    {
      name: 'Customs',
      icon: CustomsIcon,
      path: '/products/customs',
    },
    {
      name: 'Warehouse',
      icon: WarehouseIcon,
      path: '/products/warehouse',
    },
    {
      name: 'Transport',
      icon: TransportIcon,
      path: '/products/transport',
    },
    {
      name: 'Finance',
      icon: FinanceIcon,
      path: '/products/finance',
    },
    {
      name: 'Insights',
      icon: InsightsIcon,
      path: '/products/analytics',
    },
  ];

  return (
    <div className="colorpage-container services-section">
      <p className="section-title services-section-title header-2">{content.title}</p>
      <div className="services-container">
        {services.map((service, index) => (
          <Link to={service.path} className="service-card" key={index}>
            <div className="service-round-icon-container">
              <img src={service.icon} alt={service.name} />
            </div>
            <p className="service-name body-text-3">{service.name}</p>
          </Link>
        ))}
      </div>
      <div className="loved-section card">
        <p className="body-text-2">Loved by 6000+ users across the globe</p>
      </div>
    </div>
  );
};

export default Services;
